import { render, staticRenderFns } from "./RehabCourseDetail.vue?vue&type=template&id=1913123d&scoped=true"
import script from "./RehabCourseDetail.vue?vue&type=script&lang=js"
export * from "./RehabCourseDetail.vue?vue&type=script&lang=js"
import style0 from "./RehabCourseDetail.vue?vue&type=style&index=0&id=1913123d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1913123d",
  null
  
)

export default component.exports